import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import { QueryClientProvider, QueryClient, useQuery } from "react-query";
import { StoreProvider } from "./store";
import api from "api";
import { Toaster } from "react-hot-toast";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const App = () => {
	useQuery(["authRefresh"], api.auth.refresh, { enabled: !!localStorage.getItem("genius-order:authToken") });

	return <RouterProvider router={router} />;
};

root.render(
	<React.StrictMode>
		<Toaster position="top-center" />
		<QueryClientProvider client={queryClient}>
			<StoreProvider>
				<App />
			</StoreProvider>
		</QueryClientProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
